import { combineReducers } from 'redux';
import myMicrosite from './ducks/myMicrosite';

const combinedReducers = combineReducers({
  myMicrosite
});

export default (state, action) => {
  return combinedReducers(state, action);
};
